import React from "react";
import Toggle from "../Toggle/Toggle";

export interface IToggleItem<IdType> {
  id: IdType;
  value: boolean;
  label: string;
}

export interface IToggleGroupProps<IdType> {
  /** Is the group toggled on? */
  on: boolean;
  /** Is the group disabled? */
  disabled: boolean;
  /** Display name for the group */
  name: string;
  /** Function called when the whole group is toggled */
  onGroupToggle: () => void;
  /** Items to render within the group */
  items: IToggleItem<IdType>[];
  /** Function called when an item is toggled */
  onItemToggle: (itemId: IdType) => void;
}

const ToggleGroup = <T extends unknown>({
  name,
  on,
  items,
  disabled,
  onGroupToggle,
  onItemToggle,
}: IToggleGroupProps<T>): JSX.Element => (
  <div className="toggle-group">
    <div className="toggle-group__container">
      <div className="toggle-group__name">
        <Toggle disabled={disabled} value={on} label={name} onChange={() => onGroupToggle()} />
      </div>

      <div className="toggle-group__items">
        {items.map((item) => (
          <div key={String(item.id)} className="toggle-group__item">
            <Toggle disabled={disabled} value={item.value} label={item.label} onChange={() => onItemToggle(item.id)} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ToggleGroup;
